import { Typography } from "@mui/material"
import AppTextField from "components/StyledComponents/AppTextField"
import { FieldArray } from "formik"
import React from "react"
import { Col, Row } from "react-bootstrap"
import ClearIcon from "@mui/icons-material/Clear"
import { useTheme } from "@mui/system"
import StyledLabel from "components/StyledComponents/StyledLabel"

const AddStep = ({ formik, showSteps, values, stepLabel, name, buttonText, label }) => {
  const theme = useTheme()
  return (
    <Row className="w-100 m-0 mt-4">
      <StyledLabel>{label}</StyledLabel>
      <FieldArray
        name={name}
        render={(arrayHelper) => (
          <>
            {values?.map((ingrediant, index) => (
              <Row
                className="mt-2"
                style={{ paddingRight: 0 }}
                id={`${name}-${index}`}
                key={`${name}-${index}`}>
                {showSteps && (
                  <Col
                    lg="1"
                    style={{
                      display: "flex",
                      alignItems: "center"
                    }}
                    className="align-items-center">
                    <Typography
                      variant="body1Regular"
                      sx={{
                        color: theme.palette.secondary.main,
                        textUnderlineOffset: "2px"
                      }}>
                      {stepLabel}
                      {` ${index + 1}`}
                    </Typography>
                  </Col>
                )}
                <Col lg="10">
                  <AppTextField
                    id="ingredient"
                    name="ingredient"
                    type="text"
                    fullWidth
                    placeholder={`Enter ${
                      label === "Recipe with Measurements" ? "Recipe" : "Ingredient"
                    }`}
                    value={ingrediant?.name}
                    onChange={(event) => {
                      formik.setFieldValue(`${name}[${index}].name`, event.target.value)
                    }}
                  />
                </Col>
                {index > 0 && (
                  <Col lg="1" style={{ display: "flex", justifyContent: "center" }}>
                    <span role="button" onClick={() => arrayHelper.remove(index)}>
                      <ClearIcon sx={{ width: "30px", height: "48px" }} />
                    </span>
                  </Col>
                )}
              </Row>
            ))}
            <Row className="w-100 m-0 mt-2 justify-content-end">
              <Col
                lg="12"
                style={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}>
                <Typography
                  variant="body1Regular"
                  onClick={() =>
                    arrayHelper.push({
                      name: "",
                      step: ""
                    })
                  }
                  sx={{
                    color: theme.palette.secondary.main,
                    textDecoration: "underline",
                    cursor: "pointer",
                    textUnderlineOffset: "2px"
                  }}>
                  {buttonText}
                </Typography>
              </Col>
            </Row>
          </>
        )}
      />
    </Row>
  )
}

export default AddStep
